module.exports = __webpack_public_path__ + "img/icon-items.77a6341b.svg";